import { render, staticRenderFns } from "./PlanBoard.vue?vue&type=template&id=45ec56c9&scoped=true"
import script from "./PlanBoard.vue?vue&type=script&lang=js"
export * from "./PlanBoard.vue?vue&type=script&lang=js"
import style0 from "./PlanBoard.vue?vue&type=style&index=0&id=45ec56c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec56c9",
  null
  
)

export default component.exports